import { IonCard, IonCardContent, IonCol, IonIcon, IonRow, IonText } from "@ionic/react";
import { alertCircleOutline, arrowBackCircleOutline, barcodeOutline, caretBackCircleOutline, caretBackOutline, giftOutline, imageOutline, playCircleOutline } from "ionicons/icons";

import { Swiper, SwiperSlide } from 'swiper/react';
import SlideContent from "../../../components/slide-content/SlideContent";
import { Empty } from "../../../layouts/errors/Empty";

import { Controller, Pagination } from "swiper";
import { useState } from "react";
import { useHistory } from "react-router";

import './Plates.css';

interface Props {
  items: any;
}

const Plates: React.FC<Props> = (props) => {
  const history = useHistory();

  const handleFileClick = (files: any, index: number) => {
    var finalFiles = [];
    for (const idx in files) {
      finalFiles.push({ url: files[idx].link, download: files[idx].download });
    }

    history.push(history.location.pathname + '/images', { images: finalFiles, index: index, download: true });
  };

  return (
    <SlideContent class="plate" type="segment">
      <IonCard>
        <Empty length={props.items == null ? 0 : props.items?.length} icon={alertCircleOutline} text="پلاکی وجود ندارد!">
          <IonCardContent>
            {props.items?.map((element: any) => {
              return (
                <div className="plate-item" key={element.unique_id}>
                  <div>
                    <IonIcon className="plate-item-icon" icon={caretBackCircleOutline} />
                    <IonText className="plate-item-id"><strong>شناسه {element.unique_id}</strong></IonText>
                  </div>
                  <IonRow className="plate-item-files">
                    {(element.files == null || element.files.length == 0)
                      ?
                      <IonCol className="plate-item-empty"><IonText>فایلی ثبت نشده است.</IonText></IonCol>
                      :
                      element.files?.map((file: any, index: number) => (
                        <IonCol size="4">
                          <div
                            key={`${element.unique_id}-${index}`}
                            onClick={() => handleFileClick(element.files!, index)}
                            className={"plate-file-item " + (file.file_type === "VIDEO" ? "plate-video" : "")}
                            role="button">
                            {file.file_type === "VIDEO" ? (
                              <IonIcon icon={playCircleOutline} color="light" />
                            ) : file.thumb ? (
                              <img src={file.thumb} alt={file.file_type} />
                            ) : (
                              <IonIcon icon={imageOutline} />
                            )}
                          </div>
                        </IonCol>
                      ))}
                  </IonRow>
                </div>
              );
            })}
          </IonCardContent>
        </Empty>
      </IonCard>
    </SlideContent>
  );
};

export default Plates;
